<template>
    <div class="max-w-6xl mx-auto flex flex-col items-center space-y-6">
        <!-- Video Player -->
        <video ref="videoPlayer" class="w-full rounded-lg shadow-lg" :src="videoSrc" @timeupdate="updateProgress"
            controls></video>

        <!-- Controls -->
        <div class="flex space-x-4">
            <button @click="togglePlay" class="px-6 py-3 rounded-lg text-lg  focus:outline-none flex items-center space-x-2"
            :class="isPlaying ? 'bg-blue-500 hover:bg-blue-600 text-white' : 'bg-gray-200 hover:bg-gray-300 text-gray-700'">
                
                <span>{{ isPlaying ? '⏸️ Pause' : '▶️ Play' }}</span>
            </button>
            <button @click="changeSpeed(1)"
                class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg text-lg hover:bg-gray-300 focus:outline-none flex items-center space-x-2">
                <span>🐢 1x</span>
            </button>
            <button @click="changeSpeed(1.25)"
                class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg text-lg hover:bg-gray-300 focus:outline-none flex items-center space-x-2">
                <span>🚶‍♂️ 1.25x</span>
            </button>
            <button @click="changeSpeed(1.5)"
                class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg text-lg hover:bg-gray-300 focus:outline-none flex items-center space-x-2">
                <span>🏃‍♂️ 1.5x</span>
            </button>
            <button @click="changeSpeed(2)"
                class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg text-lg hover:bg-gray-300 focus:outline-none flex items-center space-x-2">
                <span>💨 2x</span>
            </button>
        </div>

        <!-- Progress -->
        <div class="text-lg text-gray-700">
            <span>{{ currentTimeFormatted }}</span> / <span>{{ durationFormatted }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "VideoPlayer",
        props: {
            videoSrc: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                isPlaying: false,
                currentTime: 0,
                duration: 0,

            };
        },
        computed: {
            currentTimeFormatted() {
                return this.formatTime(this.currentTime);
            },
            durationFormatted() {
                return this.formatTime(this.duration);
            },
        },
        methods: {
            togglePlay() {
                const video = this.$refs.videoPlayer;
                if (video.paused) {
                    video.play();
                    this.isPlaying = true;
                } else {
                    video.pause();
                    this.isPlaying = false;
                }
            },
            changeSpeed(speed) {
                const video = this.$refs.videoPlayer;
                video.playbackRate = speed;
            },
            updateProgress() {
                const video = this.$refs.videoPlayer;
                this.currentTime = video.currentTime;
                this.duration = video.duration;
            },
            formatTime(seconds) {
                const minutes = Math.floor(seconds / 60);
                const secs = Math.floor(seconds % 60);
                return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
            },
        },
        mounted() {
            const video = this.$refs.videoPlayer;
            video.playbackRate = 1.25; // Set default playback speed

            const params = new URLSearchParams(window.location.search);
            const start = params.get("start");
            
            if( ! isNaN(start) ){

                video.currentTime  = parseInt(start);
            }  

        
        },
    };
</script>

<style scoped>
    /* Scoped styles are unnecessary since Tailwind handles styling. */
</style>